const RESIZE_OBSERVER_LOOP_MESSAGES = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
] as const;

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return '';
}

export function isResizeObserverLoopError(error: unknown): boolean {
  const message = getErrorMessage(error);
  return RESIZE_OBSERVER_LOOP_MESSAGES.some(
    (resizeObserverMessage) => message === resizeObserverMessage
  );
}

export const ignoredBrowserErrorMessages = [
  ...RESIZE_OBSERVER_LOOP_MESSAGES,
  'Non-Error promise rejection captured',
  'NetworkError',
  'Failed to fetch',
  'Unauthorized',
] as const;
